// import { graphql, StaticQuery } from 'gatsby'
import React, { useState } from 'react'
import Layout from '../components/microsites/micrositeLayout'

// const query = graphql`
//   query MicrositeTitleQuery {
//     site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
//       title
//     }
//     companyInfo: sanityCompanyInfo(_id: { regex: "/(drafts.|)companyInfo/" }) {
//       name
//       address1
//       address2
//       zipCode
//       city
//       country
//     }
//   }
// `

function LayoutContainer (props) {
  const [showNav, setShowNav] = useState(false)
  function handleShowNav () {
    setShowNav(true)
  }
  function handleHideNav () {
    setShowNav(false)
  }
  return (
   
    <Layout
      {...props}
      showNav={showNav}
      onHideNav={handleHideNav}
      onShowNav={handleShowNav}
    />
  )
}

export default LayoutContainer
